import ctl from '@netlify/classnames-template-literals';

const menuContainerStyle = ctl(`
  relative
  inline-block
`);

const listStyle = ctl(`
  absolute
  mt-[5px]
  z-50
  right-1
  top-full 
  border-[1px]
  border-black
  border-opacity-10
  shadow-cetacean-blue
  bg-white 
  min-w-[150px]
  rounded-md 
  overflow-hidden
  text-waterspout
  text-[15px]
  w-full
`);

const deleteBtnStyle = ctl(`
  offset-base
  hover:bg-ghost-white
  border-t-[1px] 
  border-azureish-white
  text-orange-soda
  w-full
  text-left
`);

const btnStyle = ctl(`
  offset-base
  hover:bg-ghost-white 
  w-full
  text-left
`);

const menuButtonStyle = ctl(`
  text-xl
  cursor-pointer
`);

export { menuContainerStyle, listStyle, deleteBtnStyle, btnStyle, menuButtonStyle };
